/**
 * Validation message helpers for reseller form fields.
 * Each function receives the vuelidate field object and returns
 * an error string when invalid, or "" when valid.
 */


/**
 * Validates the company name field.
 * @param {*} field  - The vuelidate field object for the company name input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateCompanyName = (field) => {
    if (!field.$error) return "";
    if (!field.required) return "Business name is required";
    if (!field.minLength) return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} characters`;
    return "";
};

/**
 * Validates the legal name field.
 * @param {*} field  - The vuelidate field object for the legal name input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateLegalName = (field) => {
    if (field.$error) {
        return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} characters`;
    }
    return "";
};

/**
 * Validates the IATA code field.
 * @param {*} field  - The vuelidate field object for the IATA code input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateIataCode = (field) => {
    if (field.$error) {
        return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} characters`;
    }
    return "";
};

/**
 * Validates the VAT number field.
 * @param {*} field  - The vuelidate field object for the VAT number input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateVatNumber = (field) => {
    if (field.$error) {
        return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} characters`;
    }
    return "";
};

/**
 * Validates the first name field.
 * @param {*} field  - The vuelidate field object for the first name input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateFirstName = (field) => {
    if (!field.$error) return "";
    if (!field.required) return "First name is required";
    if (!field.minLength) return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} letters`;
    return "";
};

/**
 * Validates the last name field.
 * @param {*} field  - The vuelidate field object for the last name input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateLastName = (field) => {
    if (!field.$error) return "";
    if (!field.required) return "Last name is required";
    if (!field.minLength) return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} letters`;
    return "";
};

/**
 * Validates the email field.
 * @param {*} field  - The vuelidate field object for the email input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateEmailField = (field) => {
    if (!field.$error) return "";
    if (!field.required) return "Email is required";
    if (!field.email) return "Email is invalid";
    if (!field.customValidator) return "Email is already in use";
    return "";
};

/**
 * Validates the street field.
 * @param {*} field  - The vuelidate field object for the street input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateStreet = (field) => {
    if (field.$error) {
        return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} characters`;
    }
    return "";
};

/**
 * Validates the city field.
 * @param {*} field  - The vuelidate field object for the city input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateCity = (field) => {
    if (field.$error) {
        return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} letters`;
    }
    return "";
};

/** Validates the state field.
 * @param {*} field  - The vuelidate field object for the state input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateState = (field) => {
    if (field.$error) {
        return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} letters`;
    }
    return "";
};

/** Validates the zip code field.
 * @param {*} field  - The vuelidate field object for the zip code input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateZipCode = (field) => {
    if (field.$error) {
        return `Enter from ${field.$params.minLength.min} to ${field.$params.maxLength.max} characters`;
    }
    return "";
};

/** Validates the country field.
 * @param {*} field  - The vuelidate field object for the country input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateMarkupField = (field) => {
    if (field.$error) {
        return `Must be between ${field.$params.between.min}% and ${field.$params.between.max}%`;
    }
    return "";
};

/** Validates the commission field.
 * @param {*} field  - The vuelidate field object for the commission input.
 * @returns {string} - An error message if invalid, or an empty string if valid.
 */
export const validateCommission = (field) => {
    if (field.$error) {
        return `Must be between ${field.$params.between.min}% and ${field.$params.between.max}%`;
    }
    return "";
};